import { render, staticRenderFns } from "./ImageSlider.vue?vue&type=template&id=00da1c53&scoped=true&"
import script from "./ImageSlider.vue?vue&type=script&lang=js&"
export * from "./ImageSlider.vue?vue&type=script&lang=js&"
import style0 from "./ImageSlider.vue?vue&type=style&index=0&id=00da1c53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00da1c53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
